"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneNumberChangeEvent = exports.PhoneNumberActions = void 0;
exports.addPhoneNumberAction = addPhoneNumberAction;
exports.editPhoneNumberAction = editPhoneNumberAction;
exports.getPhoneNumbersAction = getPhoneNumbersAction;
exports.removePhoneNumberAction = removePhoneNumberAction;
exports.resetApiErrorAction = resetApiErrorAction;
var _phoneNumbersApi = require("../../../api-factory/phoneNumbersApi");
var PhoneNumberChangeEvent = exports.PhoneNumberChangeEvent = /*#__PURE__*/function (PhoneNumberChangeEvent) {
  PhoneNumberChangeEvent["ADD"] = "add";
  PhoneNumberChangeEvent["EDIT"] = "edit";
  PhoneNumberChangeEvent["REMOVE"] = "remove";
  PhoneNumberChangeEvent["LOAD"] = "load";
  PhoneNumberChangeEvent["NONE"] = "none";
  return PhoneNumberChangeEvent;
}({});
var PhoneNumberActions = exports.PhoneNumberActions = /*#__PURE__*/function (PhoneNumberActions) {
  PhoneNumberActions["HAS_API_ERROR"] = "HAS_API_ERROR";
  PhoneNumberActions["LOAD_PHONE_NUMBERS"] = "LOAD_PHONE_NUMBERS";
  PhoneNumberActions["IS_LOADING"] = "IS_LOADING";
  PhoneNumberActions["IS_EDITING"] = "IS_EDITING";
  PhoneNumberActions["FINISHED_EDITING"] = "FINISHED_EDITING";
  PhoneNumberActions["RESET_API_ERROR"] = "RESET_API_ERROR";
  PhoneNumberActions["RESET_CHANGE_EVENT_TYPE"] = "RESET_CHANGE_EVENT_TYPE";
  return PhoneNumberActions;
}({});
function getPhoneNumbersAction(dispatch, contractId) {
  setLoading(dispatch, PhoneNumberChangeEvent.LOAD);
  getAllPhoneNumbersOfContractId(dispatch, contractId);
}
function addPhoneNumberAction(dispatch, phoneNumberObject, contractId) {
  setLoading(dispatch, PhoneNumberChangeEvent.ADD);
  return new Promise(function (resolve, reject) {
    (0, _phoneNumbersApi.addPhoneNumber)(phoneNumberObject, contractId).then(function (response) {
      handleResponse(dispatch, response, contractId);
      resolve(response);
    }).catch(function (error) {
      setHasApiError(dispatch, error.message);
      reject(error);
    });
  });
}
function editPhoneNumberAction(dispatch, phoneNumberObject, contractId) {
  setLoading(dispatch, PhoneNumberChangeEvent.EDIT);
  return new Promise(function (resolve, reject) {
    (0, _phoneNumbersApi.editPhoneNumbers)(phoneNumberObject, contractId).then(function (response) {
      handleResponse(dispatch, response, contractId);
      resolve(response);
    }).catch(function (error) {
      setHasApiError(dispatch, error.message);
      reject(error);
    });
  });
}
function removePhoneNumberAction(dispatch, phoneNumberObject, contractId) {
  setLoading(dispatch, PhoneNumberChangeEvent.REMOVE);
  (0, _phoneNumbersApi.deletePhoneNumber)(phoneNumberObject, contractId).then(function (response) {
    handleResponse(dispatch, response, contractId);
  }).catch(function (error) {
    setHasApiError(dispatch, error.message);
  });
}
function resetApiErrorAction(dispatch) {
  dispatch({
    type: PhoneNumberActions.RESET_API_ERROR
  });
}
function getAllPhoneNumbersOfContractId(dispatch, contractId) {
  dispatch({
    type: PhoneNumberActions.IS_LOADING
  });
  (0, _phoneNumbersApi.getPhoneNumbers)(contractId).then(function (response) {
    dispatch({
      type: PhoneNumberActions.LOAD_PHONE_NUMBERS,
      phoneNumbers: response.data.content
    });
  }).catch(function (error) {
    setHasApiError(dispatch, error.message);
  });
}
function setLoading(dispatch, changeEvent) {
  dispatch({
    type: PhoneNumberActions.IS_EDITING,
    changeEvent: changeEvent
  });
}
function setHasApiError(dispatch, apiErrorMessage) {
  dispatch({
    type: PhoneNumberActions.HAS_API_ERROR,
    apiErrorMessage: apiErrorMessage
  });
}
function handleResponse(dispatch, response, contractId) {
  dispatch({
    type: PhoneNumberActions.FINISHED_EDITING,
    processedPhoneNumber: response.data
  });
  getAllPhoneNumbersOfContractId(dispatch, contractId);
}